
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/coverage/same-day-link-best-practices",
      function () {
        return require("private-next-pages/docs/auth/coverage/same-day-link-best-practices.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/coverage/same-day-link-best-practices"])
      });
    }
  